let mm = gsap.matchMedia();
mm.add("(min-width: 991px)", () => {
  gsap.timeline({
    scrollTrigger: {
      trigger: ".hero__inner",
      scrub: true,
      start: 1,
      opacity: 1,
      markers: false,
      pinSpacing: false,
      pin: false
    }
  })
  .to(".hero__inner", {opacity: 0, y: 250})
});

gsap.timeline({
  scrollTrigger: {
    trigger: ".magic-card01",
    scrub: .5,
    start: "center center",
    markers: false,
    pinSpacing: false,
    pin: true
  }
})
.to(".magic-card01", {opacity: 0, y: -50, scale: .9})

gsap.timeline({
  scrollTrigger: {
    trigger: ".magic-card02",
    scrub: .5,
    start: "center center",
    markers: false,
    pinSpacing: false,
    pin: true
  }
})
.to(".magic-card02", {opacity: 0, y: -50, scale: .9})

gsap.timeline({
  scrollTrigger: {
    trigger: ".magic-card03",
    scrub: .5,
    start: "center center",
    markers: false,
    pinSpacing: false,
    pin: true
  }
})
.to(".magic-card03", {opacity: 0, y: -50, scale: .9})

gsap.timeline({
  scrollTrigger: {
    trigger: ".magic-card04",
    scrub: .5,
    start: "center center",
    markers: false,
    pinSpacing: false,
    pin: true
  }
})
.to(".magic-card04", {opacity: 0, y: -50, scale: .9})

gsap.timeline({
  scrollTrigger: {
    trigger: ".large-list",
    scrub: 1,
    markers: false,
    pinSpacing: false,
    pin: false,
    x: 0
  }
})
.to(".large-list", {x: -700})

gsap.timeline({
  scrollTrigger: {
    trigger: ".theme-banner",
    scrub: 0.04,
    markers: false
  }
})
.to(".topBanner-part", {scale: .8, opacity: 0, duration: 1}, 1.3)
.to(".blankOverlay", {opacity: 1})

mm.add("(min-width: 991px)", () => {
  gsap.timeline({
    scrollTrigger: {
      trigger: ".template-index .site-performance-video",
      scrub: 1,
      markers: false,
      start: "top 180px",
      pinSpacing: false,
      pin: true
    }
  })
  .to(".template-index .site-performance-video div img", {opacity: 1, duration: 5}, 1)
  .to(".template-index .site-performance-video > img", {scale:0.5, opacity: 0})
});

//------- Images on Index
mm.add("(min-width: 991px)", () => {

  gsap.timeline({
    scrollTrigger: {
      trigger: ".service_content",
      scrub: 1,
      markers: false,
      start: "center center",
      pin: true,
      pinSpacing: false,
    }
  })

  gsap.to(".service_sec", {
    scrollTrigger: {
      trigger: ".service_content",
      start: "bottom 65%",
      scrub: 0.5,
      markers: false,
    },
    borderRadius: "100%", // or "50%" depending on your design
    ease: "none"
  });

  gsap.to(".footer__wrapper", {
    yPercent: 100,
    opacity: 1,
    pinSpacing: false,
    ease: "none",
    scrollTrigger: {
      trigger: ".footer-bottom",
      yPercent: 0,
      scrub: true
    },
  });

});


gsap.timeline({
  scrollTrigger: {
    trigger: ".compare-section",
    scrub: .4,
    markers: false,
    pinSpacing: true,
    start: "top 100px",
    pin: true
  }
})
.to(".usedStores", {scale:1})

gsap.to(".hero-desc2 h2", {
  xPercent: 80,
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-desc2",
    scrub: true
  }, 
});

gsap.from(".projects-hero > *", {
  y: -30,
  opacity: 0,
  delay: 1.5,
  pin: true,
  ease: "none"
});

